module.exports = __webpack_public_path__ + "img/1.69cc0810.png";